import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './FormLabel.scss';

// 1. Destructure props and set ES6 defaults
const FormLabel = ({ 
  children = '', 
  center = false, 
  note, 
  className = '',
  // 'htmlFor' is the React-friendly version of 'for'
  htmlFor 
}) => {
  return (
    <div
      className={classNames('form-label__container', className, {
        'form-label__container--center': center
      })}
    >
      <span className="form-label__label">{children}</span>
      
      {/* 2. Simplified conditional rendering for the note */}
      {note && (
        <span className="form-label__note">
          <em>{note}</em>
        </span>
      )}
    </div>
  );
};

FormLabel.propTypes = {
  children: PropTypes.string,
  center: PropTypes.bool,
  note: PropTypes.string,
  className: PropTypes.string,
  htmlFor: PropTypes.string
};

export default FormLabel;
